import { useContext, useEffect } from 'react';

import { Drawer, Flex } from '@grupoboticario/flora-react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Divider } from 'components/Divider';
import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';
import config from 'config';
import { DRAWERS, QUERYPARAMS } from 'config/environments/shared';
import { FloraProvider } from 'containers/ProviderComposer/providers';
import { getPaymentStatus } from 'helpers';
import { useTracking, useDrawer, usePaymentDetail } from 'hooks';
import { GlobalContext } from 'store';

import { RenegotiationPortal, RenegotiationCentral, RenegotiationWhatsapp } from './components';
import { HeaderContentPayment } from '../components/HeaderContentPayment/HeaderContentPayment';
import Styles from '../Drawers.styles';

export const Renegotiation = () => {
  const { isOpen, searchParams } = useDrawer(DRAWERS.RENEGOTIATION);
  const { brand } = useContext(GlobalContext);
  const { data: paymentDetailData, isSuccess } = usePaymentDetail(
    searchParams.get(QUERYPARAMS.PAYMENT_ID) || ''
  );
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { sendDataToGTM } = useTracking();

  const backToPaymentDetail = () => {
    navigate(-1);
  };

  const pageLocationGA4 =
    pathname === '/pedidos'
      ? `${config.app.url}pedidos/a-pagar/renegociar-pagamento`
      : `${config.app.url}pedidos/detalhes-do-pagamento/renegociar-pagamento`;

  useEffect(() => {
    if (isSuccess) {
      sendDataToGTM({
        event: 'page_view',
        event_parameters: {
          page_location: pageLocationGA4,
          page_title: 'renegociar pagamento',
          transaction_id: paymentDetailData?.paymentTitleId,
          cd_metodo_pagamento: paymentDetailData?.planDetail.toLowerCase(),
          cd_status_pagamento:
            paymentDetailData &&
            getPaymentStatus({
              daysLate: paymentDetailData?.daysLate,
              daysUntilDueDate: paymentDetailData?.daysUntilDueDate,
              paymentStatus: paymentDetailData?.paymentStatus,
              status: paymentDetailData?.status,
            })?.tag.toLowerCase(),
          cd_dias_para_vencimento: paymentDetailData?.daysUntilDueDate,
          cd_dias_apos_vencimento: paymentDetailData?.daysLate,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, paymentDetailData, searchParams]);

  return (
    <Drawer open={isOpen} onOpenChange={backToPaymentDetail}>
      <Styles.DrawerContent side='right'>
        <FloraProvider>
          <Styles.DrawerHeader>
            <HeaderContentPayment isToBack title='Renegociar pagamento' />
          </Styles.DrawerHeader>
          <Styles.DrawerBody>
            <Styles.DrawerSection>
              <Flex direction='column' gap='$4'>
                <ResponsiveFloraTypography>
                  Escolha por qual canal você deseja realizar a negociação dos pagamentos.
                </ResponsiveFloraTypography>
                <Divider variant='Line' />
                <RenegotiationPortal />
                {brand.sac.whatsapp ? (
                  <>
                    <Divider variant='Line' />
                    <RenegotiationWhatsapp />
                  </>
                ) : null}

                <Divider variant='Line' />
                <RenegotiationCentral />
              </Flex>
            </Styles.DrawerSection>
          </Styles.DrawerBody>
        </FloraProvider>
      </Styles.DrawerContent>
    </Drawer>
  );
};
